import {atom,} from "recoil";

export const contactContentSelectedInBusiness = atom<string>({
    key: 'contactContentSelectedInBusiness',
    default: 'LED看板広告について'
})